
import AuthorizeSubscribeTime from '../authorize-dialog/components/authorize-subscribe-time.vue';
import { PlanNormal } from '@/common/permission';

export default {
  components: { AuthorizeSubscribeTime: AuthorizeSubscribeTime },
  props: {
    formValue: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      PlanNormal: PlanNormal
    };
  }
};